import env from 'env'
import { SPACE } from '../../constants'
import { preload, load } from '../../utils'

const {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  NUGSNET_CDN
} = env

export type GoogleFirebase = {
  isLoaded: boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firebaseApp: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  firestore: any
}

const google = {
  isLoaded: false,
  firebaseApp: null,
  firestore: null
} as GoogleFirebase

const url = 'firebase/8.10.0'

const s1 = 'firebase-app.min.js'
const s2 = 'firebase-firestore.min.js'

const concat = (url: string, path: string) => (NUGSNET_CDN || SPACE) + '/' + url + '/' + path

export function preloadFirebaseScripts() {
  return Promise.all([
    preload(concat(url, s1)),
    preload(concat(url, s2))
  ])
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function init(firebase = window['firebase' as never] as any) {
  if (google.isLoaded) return

  google.firebaseApp = firebase.initializeApp({
    apiKey: FIREBASE_API_KEY,
    authDomain: FIREBASE_AUTH_DOMAIN,
    projectId: FIREBASE_PROJECT_ID
  })
  google.firestore = google.firebaseApp.firestore()
  google.isLoaded = true
}

export async function initGoogleFirebase(customUrl: string | null = null): Promise<GoogleFirebase> {
  if (!google.isLoaded) {
    await load(concat(customUrl || url, s1), 'firebase'),
    await load(concat(customUrl || url, s2), 'firestore')

    init()
  } else {
    init()
  }

  return google
}

export default () => google
